import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../../utils/analytics';
import EditIcon from '@mui/icons-material/Edit';
import { openCanvaAuthWindow } from './canvaAuthHelper';
import { useDispatchAlert } from '../../../utils/customHooks';
import {
  getCanvaAuth,
  useEditImageHelper,
} from './editImageHelper';
import { useExchangeAccessTokenMutation } from '../../../services/canva';
import { AppCircularProgress } from '../../../components/AppCircularProgress';
import { Tooltip } from '@mui/material';

type TProps = {
  imgURL: string;
};

export const EditImage = ({ imgURL }: TProps) => {
  const dispatchAlert = useDispatchAlert();

  const [
    exchangeAccessToken,
    { isLoading: isRefreshTokenLoading },
  ] = useExchangeAccessTokenMutation();

  const { editImageAction, isEditImageActionLoading } =
    useEditImageHelper();

  const refreshToken = (refresh_token: string) => {
    exchangeAccessToken({ refresh_token })
      .unwrap()
      .then((res) => {
        if (res.access_token)
          editImageAction(res.access_token, imgURL);
        else openCanvaAuthorizationWindow();
      })
      .catch(() => {
        openCanvaAuthorizationWindow();
      });
  };

  const openCanvaAuthorizationWindow = () => {
    localStorage.setItem('asset_url', imgURL);
    const res = openCanvaAuthWindow();
    if (res?.error) {
      dispatchAlert(res.error);
    }
  };

  const onEditClick = () => {
    appLogEvent(CUSTOM_EVENTS.EDIT_IMAGE);
    const { isTokenExpired, canvaAuth } = getCanvaAuth();
    if (!canvaAuth) {
      openCanvaAuthorizationWindow();
    } else if (isTokenExpired || !canvaAuth.access_token) {
      if (canvaAuth.refresh_token)
        refreshToken(canvaAuth.refresh_token);
      else openCanvaAuthorizationWindow();
    } else {
      editImageAction(canvaAuth.access_token, imgURL);
    }
  };

  return (
    <>
      {(isRefreshTokenLoading ||
        isEditImageActionLoading) && (
        <AppCircularProgress />
      )}
      <Tooltip title="Edit Image">
        <a
          title="Edit with canva"
          className="edit-icon"
          onClick={onEditClick}>
          <EditIcon />
        </a>
      </Tooltip>
    </>
  );
};
